<template>
  <div class="article-nav">
    <div class="">
      <ul class="ui_tabs_help">
        <li
          v-for="(item, index) in navigation"
          :class="{ margin: index === current }"
          :key="index"
          @click="changTib(item.component, index)"
        >
          <img class="current" :src="index === current ? item.active : item.defult" />
        </li>
      </ul>
    </div>
    <div class="content">
      <component :is="currentComponent" />
    </div>
  </div>
</template>

<script>
import components from './components'
export default {
  data() {
    return {
      navigation: [
        {
          defult: 'https://res12.xesimg.com/x5mall/img/tabs_1.png',
          active: 'https://res12.xesimg.com/x5mall/img/tabs_current1.png',
          component: 'hotSpot'
        },
        {
          defult: 'https://res12.xesimg.com/x5mall/img/tabs_2.png',
          active: 'https://res12.xesimg.com/x5mall/img/tabs_current2.png',
          component: 'direction'
        },
        {
          defult: 'https://res12.xesimg.com/x5mall/img/tabs_3.png',
          active: 'https://res12.xesimg.com/x5mall/img/tabs_current3.png',
          component: 'system'
        },
        {
          defult: 'https://res12.xesimg.com/x5mall/img/tabs_4.png',
          active: 'https://res12.xesimg.com/x5mall/img/tabs_current4.png',
          component: 'help'
        }
      ],
      current: 0,
      currentComponent: 'hotSpot'
    }
  },
  components: {
    ...components
  },
  methods: {
    changTib(component, index) {
      this.currentComponent = component
      this.current = index
    }
  }
}
</script>

<style lang="scss" scoped>
.article-nav {
  width: 980px;
  margin: 0 auto 20px;
  overflow: hidden;
}
.ui_tabs_help {
  height: 76px;
  overflow: hidden;
  margin-top: 15px;
  padding-left: 40px;
  background: url(https://res12.xesimg.com/x5mall/img/tabs_bg.png) repeat-x;
}
.ui_tabs_help li {
  padding: 0;
  list-style: none;
  float: left;
  display: inline;
  width: 218px;
  margin: 19px 10px 0 0;
}
.ui_tabs_help li a {
  display: block;
  width: 218px;
  height: 66px;
}
.margin {
  margin-top: 10px !important;
}
</style>



// WEBPACK FOOTER //
// ./src/views/ArticleNav/index.vue